import { odin } from "./odin"
import { cronos } from "./cronos"

export const api = {
  odin,
  cronos,
}
